import React from "react";
import {
  IWebsiteBuilderEmbed,
  websiteBuilderGenerateEmbedDesignStyles,
  websiteBuilderGenerateEmbedIframeSettings,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderEmbed";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface IWebsiteBuilderEmbedViewProps {
  node: IWebsiteBuilderEmbed;
}

export function WebsiteBuilderEmbedView(props: IWebsiteBuilderEmbedViewProps) {
  const { node } = props;

  const { t } = useTranslation();

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateEmbedDesignStyles();

  function renderContent() {
    const iframeSettings = websiteBuilderGenerateEmbedIframeSettings(settings);

    if (iframeSettings == null) {
      return (
        <div className="editor-embed-instruction">
          {settings.code?.length > 0 ? (
            <h3>{t("Invalid embed")}</h3>
          ) : (
            <>
              <h3>{t("Add an embed")}</h3>
              <p>{t("Double-click to configure an embed")}</p>
            </>
          )}          
        </div>
      );
    } else {
      return (
        <iframe
          className={designStyles.className}
          style={designStyles.styleProperties}
          {...iframeSettings}
        />
      );
    }
  }

  return (
    <div className={classNames(designStyles.containerClassName, "editor-embed-container")}>
      {renderContent()}
    </div>
  );
}